import { GlobalEnableStatus } from 'common/enums';
import i18n from 'common/i18n';

export function getGlobalEnableStatusLabel(value: number) {
    const status = GlobalEnableStatus[value] ?? 'pending';
    return i18n.t(`term.${status}`);
}
